<template>
  <div class="charge-detail">
    <div class="main-title bbn">
      <p> {{ $t('lang.Central Control Information') }}</p>
    </div>
    <div class="main-info">
      <div class="item">
        <div>{{ $t('lang.Central Control Number') }}:</div>
        <div>{{ info.udid }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Equipment State') }}:</div>
        <div>{{ getDeviceStatus(info) }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Total Mileage') }}:</div>
        <div>{{ info.totalMile }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Central Control State') }}</div>
        <div class="class-button">{{ info.serviceStatus }}</div>
        <div class="class-button" @click="changeStatus">{{ $t('lang.Switch State') }}</div>
      </div>
    </div>
    <div class="main-title bbn">
      <p> {{ $t('lang.Vehicle Information') }}</p>
    </div>
    <div class="main-info">
      <div class="item">
        <div>{{ $t('lang.Vehicle Frame Number') }}:</div>
        <div>{{ info.vinNo }}</div>
        <div class="class-button" @click="qrcodeDialogVisible = true">{{ $t('lang.View QR Code') }}</div>
      </div>
    </div>
    <div class="main-title bbn">
      <p> {{ $t('lang.Battery Information') }}</p>
    </div>
    <div class="main-info">
      <div class="item">
        <div>{{ $t('lang.Battery Number') }}:</div>
        <div>{{ info.batteryNo }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Electricity') }}:</div>
        <div>{{ info.batteryElectricity }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Battery Health Level') }}:</div>
        <div>{{ info.batteryHealth }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Battery Temperature') }}:</div>
        <div>{{ info.batteryTemperature }}</div>
      </div>
    </div>
    <div class="main-title bbn">
      <p> {{ $t('lang.User Information') }}</p>
    </div>
    <div class="main-info">
      <div class="item">
        <div>{{ $t('lang.Account Number') }}:</div>
        <div>{{ info.userId }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.The User Mileage') }}:</div>
        <div>{{ info.userMileage }}</div>
      </div>
      <div class="item">
        <div>{{ $t('lang.Today s Mileage') }}:</div>
        <div>{{ info.userTodayMileage }}</div>
      </div>
    </div>
    <el-dialog :title="$t('lang.View QR Code')" :visible.sync="qrcodeDialogVisible" width="30%">
      <div class="qr-code-box">
        <el-image :src="qrcodeSrc"></el-image>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {queryThailandElectricBicycleDetail, thailandElectricBicycleOperate} from '../../api/deviceManagement';
import {queryQrCode} from '../../api/common';

export default {
  name: 'electricBicycleMgmtDetailView',
  props: {
    deviceStatusList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      //是否显示二维码
      qrcodeDialogVisible: false,
      qrcodeSrc: '',
      info: {},
      number: '',
      //正在切换状态的标志
      isChangeStatusLoadingFlag: false
    }
  },
  watch: {
    editData: {
      handler(newVal) {
        this.number = newVal.number
        this.queryThailandElectricBicycleDetail()
      },
      deep: true,
    },
  },
  methods: {
    getDeviceStatus(item) {
      const statusItem = this.deviceStatusList.find((el) => {
        return el.value == item.statusCode
      })
      if(statusItem) {
        return statusItem.label
      }
      return ''
    },
    /**
     * 切换状态按钮点击
     */
    changeStatus() {
      const self = this;
      this.$confirm(this.$t('Whether to switch states'), "", {
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('Cancel'),
        type: "warning"
      }).then(()=>{
        self.toChangeStatus();
      })
    },
    /**
     * 进行切换状态
     */
    async toChangeStatus() {
      if(this.isChangeStatusLoadingFlag) {
        this.$message.warning(this.$t('In operation') + '...')
        return
      }
      const params = {
        udid: this.info.udid,
        operation: this.info.serviceStatus === 'unlock' ? 'lock' : 'unlock'
      }
      try {
        this.isChangeStatusLoadingFlag = true
        await thailandElectricBicycleOperate(params)
        this.isChangeStatusLoadingFlag = false
        this.$message.success(this.$t('lang.Successful'))
        this.queryThailandElectricBicycleDetail()
      } catch (e) {
        this.isChangeStatusLoadingFlag = false
      }
    },
    /**
     * 获取电动车的详情
     */
    async queryThailandElectricBicycleDetail() {
      const params = {
        number: this.number
      }
      const res = await queryThailandElectricBicycleDetail(params)
      this.info = res.mdata.electricBicycleDto || {}
      this.queryQrCode(res.mdata.link)
    },
    /**
     * 获取二维码
     * @param info
     */
    async queryQrCode(info) {
      const params = {
        link: info.link
      }
      const res = await queryQrCode(params)
      this.qrcodeSrc = res.mdata.qrCode
    }
  },
}
</script>
<style lang="scss" scoped>
.charge-detail {
  .main-title {
    position: relative;
  }
  .bbn {
    border-bottom: none;
  }
  .main-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 10px 40px;
    .item {
      display: flex;
      align-items: center;
      font-size: 15px;
      margin: 10px 70px 20px 0;
      .class-button {
        margin-left: 50px;
        color: #4CB132;
      }
    }
  }
  .qr-code-box {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleDetailView.vue